import { ClipboardPlus } from 'lucide-react';

import { hasMedicalData } from '~entities/student/lib/medical';
import type { Medical } from '~entities/student/modal/medical';

export interface StudentNameWithMedicalBadgeProps {
  name: string;
  medical: Medical;
  /** Optional class for the name wrapper (e.g. font-medium) */
  nameClassName?: string;
}

export const StudentNameWithMedicalBadge = ({
  name,
  medical,
  nameClassName,
}: StudentNameWithMedicalBadgeProps) => {
  const hasMedical = hasMedicalData(medical);
  return (
    <div className='flex items-center gap-2'>
      <span className={nameClassName}>{name}</span>
      {hasMedical && (
        <ClipboardPlus
          className='size-4 shrink-0 text-red-400'
          aria-label='Has medical details'
        />
      )}
    </div>
  );
};
